import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy, Medal, CheckCircle2 } from "lucide-react";

export default function StaffLeaderboard({ es }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/learn/staff/leaderboard").then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, []);
  if (!rows || rows.length === 0) return null;
  const medal = (r) => (r.rank === 1 ? "text-amber-300" : r.rank === 2 ? "text-slate-300" : r.rank === 3 ? "text-orange-400" : "text-slate-600");
  return (
    <div className="p-3 rounded-xl border border-slate-800 bg-[#131722] space-y-2" data-testid="staff-leaderboard">
      <p className="font-mono text-[10px] tracking-widest uppercase text-cyan-400 flex items-center gap-1.5"><Trophy className="w-3.5 h-3.5" />{es ? "Tabla del equipo" : "Team leaderboard"}</p>
      <ol className="space-y-1.5">
        {rows.slice(0, 10).map((r) => (
          <li key={r.user_id} data-testid={`leaderboard-row-${r.user_id}`} className={`flex items-center gap-2 text-xs rounded-lg px-2 py-1.5 ${r.you ? "bg-cyan-500/10 border border-cyan-500/30" : ""}`}>
            <Medal className={`w-3.5 h-3.5 shrink-0 ${medal(r)}`} />
            <span className="font-mono text-slate-500 w-4">{r.rank}</span>
            <span className="flex-1 truncate font-semibold text-slate-200">{r.name}{r.you ? (es ? " (tú)" : " (you)") : ""}</span>
            <span className="font-mono text-slate-400">{r.watched}/15</span>
            <span className="font-mono text-slate-400 w-8 text-right">{r.score != null ? `${r.score}/6` : "—"}</span>
            {r.finished ? <span className="text-emerald-300 flex items-center gap-1 font-mono" title={r.finished_at}><CheckCircle2 className="w-3.5 h-3.5" />{r.finished_at ? new Date(r.finished_at).toLocaleDateString() : ""}</span> : <span className="w-4" />}
          </li>
        ))}
      </ol>
    </div>
  );
}
